import React, { useState } from "react";
import { Icon } from "semantic-ui-react";
import { authService } from "../../store/services/ServiceAuth";

function GoogleSignInButton({ nextPath, label, onBeforeStart, disabled }) {
    const [pending, setPending] = useState(false);
    const [error, setError] = useState("");

    const start = async () => {
        if (disabled || pending) {
            return;
        }
        if (onBeforeStart && onBeforeStart() === false) {
            return;
        }
        setPending(true);
        setError("");
        const result = await authService.startGoogleLogin(nextPath);
        const url = result && result.response && result.response.url;
        if (result && result.status === 200 && url) {
            window.location.assign(url);
            return;
        }
        setPending(false);
        setError("Prihlásenie cez Google sa nepodarilo spustiť.");
    };

    return (
        <>
            <button
                type="button"
                onClick={start}
                disabled={disabled || pending}
                style={{
                    width: "100%",
                    background: "#fff",
                    color: "var(--dark)",
                    border: "1px solid #dadce0",
                    borderRadius: "8px",
                    padding: "0.9rem",
                    fontSize: "1rem",
                    fontWeight: "bold",
                    cursor: disabled || pending ? "not-allowed" : "pointer",
                    opacity: disabled || pending ? 0.55 : 1,
                }}
            >
                <Icon name="google" />
                {label || "Pokračovať cez Google"}
            </button>
            {error ? (
                <p style={{ margin: "0.5rem 0 0", color: "#9f3a38", fontSize: "0.9rem" }}>{error}</p>
            ) : null}
        </>
    );
}

export default GoogleSignInButton;
